import { getRunDetail } from '../../graphql/queries';
import { API } from 'aws-amplify';

export async function fetchAndFormatRunDetails(run_id, car_num) {
  async function fetchRunDetails(run_id) {
    try {
      const apiData = await API.graphql({
        query: getRunDetail,
        variables: { id: run_id },
      });
      const r = apiData.data.getRunDetail;
      const runJson = JSON.parse(r.runJson);
      const runTimings = JSON.parse(r?.runTimings);
      return {
        eventId: runJson.event_id,
        runId: runJson.run_id,
        runJson: runJson,
        runTimings: runTimings,
      };
    } catch (error) {
      console.log(error);
    }
  }
  async function calculateRunTimings(run_details) {
    const laps = run_details?.runJson?.results?.find(
      (result) => String(result.racer_number) === String(car_num)
    )?.laps;
    const laptimes = laps.map((lap) => lap.time);

    let s;
    // change s to crossStartLineOffset if you want
    const cumulativeLapTimes = laptimes.map(((s = 0), (n) => (s += n)));
    laps.forEach((lap, index) => (lap.timeCumm = cumulativeLapTimes[index]));
    // add a start time marker into the lap object so we don't always have to look forward.
    const somethingNew = laps.map((lap, index) => {
      if (lap.number === 1) {
        lap = { ...lap, timeCummLapStart: 0 };
        return lap;
      } else if (lap.number <= laps.length) {
        lap = { ...lap, timeCummLapStart: laps[index - 1].timeCumm };
        return lap;
      } else {
        console.log(
          `Possible error. Index is ${index} laps.length is ${laps.length}`
        );
      }
      return laps;
    });
    return somethingNew;
  }
  const res = await fetchRunDetails(run_id);
  const laptimeData = await calculateRunTimings(res);
  return laptimeData;
}
